export const CREDENTIALS_ERROR = "Usuario o contraseña incorrectos."
export const NO_MODULES_ASIGNED_ERROR = "No se han asignado módulos a su usuario."